export const manageAppAnchors = {
  installabilityDiagnostics: 'pwa-installability-diagnostics',
  installInstructions: 'pwa-install-instructions',
} as const

